<template>
    <div id="GestionIncidencias_div" class="w-100 px-0 py-0">
        <div id="TituloGestionIncidencias_div">
            <h5 class="label-black" style="margin-bottom: 0px;">INCIDENCIAS</h5>
            <h6 class="label-black" style="margin-top: 0px;">Gestión de Incidencias</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" v-if="(AreaUsuario.AreaId==79 || AreaUsuario.AreaId==25) || Titular == true">
                <div class="area custom-area">
                    <h6 class="label-black">Búsqueda del Servidor Público</h6>
                    <hr/>
                    <div class="form-group" id="Nombre_div">
                        <label class="label-black">Nombre</label>
                        <input class="form-control" type="text" placeholder="Nombre(s) y/o Apellido(s)" v-model="busqueda.Nombre" @change="CambiaNombre()" v-on:keyup.enter='BuscarServidor()'/>
                    </div>
                    <div class="form-group" id="Nomina_div">
                        <label class="label-black">No. de Nómina</label>
                        <input class="form-control" type="number" placeholder="#####" v-model="busqueda.Nomina" @change="CambiaNomina()" v-on:keyup.enter='BuscarServidor()'/>
                    </div>
                    <div id="BotonBusqueda_div" class="text-right">
                        <button class="btn btn-sm btn-custom"  @click='BuscarServidor()'>Buscar Servidor Público</button>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" v-if="DatosPersona!=null && DatosPersona.PersonaId>0">
                <div class="area custom-area">
                    <div class="row">
                        <div class="form-group col-8" >
                            <h5 class="label-black">Datos del Servidor Público</h5>
                        </div>
                        <div class="form-group col-4 text-center" v-if="Antiguedad.Años>=2">
                            <h6 class="p-2 mb-2 bg-success label-black">{{Antiguedad.Etiqueta}}</h6>
                        </div>
                        <div class="form-group col-4 text-center" v-else-if="Antiguedad.Años==0 && Antiguedad.Meses==0 && Antiguedad.Dias==0">
                            <h6 class="p-2 mb-2 bg-danger label-black">Antigüedad no determinada</h6>
                        </div>
                        <div class="form-group col-4 text-center" v-else>
                            <h6 class="p-2 mb-2 bg-warning label-black">{{Antiguedad.Etiqueta}}</h6>
                        </div>
        
                    </div>
                    <hr>
                    <div class="row">
                        <div class="form-group col-9" >
                            <label class="label-black">Nombre</label>
                            <input type="text" class="form-control" v-model="DatosPersona.NombreCompleto" readonly />
                        </div>
                        <div class="form-group col-3" >
                            <label class="label-black">No. Nómina</label>
                            <input type="text" class="form-control" v-model="DatosPersona.NumeroNomina" readonly />
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12" >
                            <label class="label-black">Puesto</label>
                            <input type="text" class="form-control" v-model="DatosPersona.Puesto" readonly />
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-6" >
                            <label class="label-black">Departamento</label>
                            <input type="text" class="form-control" v-model="DatosPersona.Departamento" readonly />
                        </div>
                        <div class="form-group col-6" >
                            <label class="label-black">Área</label>
                            <input type="text" class="form-control" v-model="DatosPersona.Seccion" readonly />
                        </div>
                    </div>
                    <div class="row" v-if="(AreaUsuario.AreaId==79 || AreaUsuario.AreaId==25)">
                        <div class="form-group col-12" >
                            <h6 class="label-black">Historial de Incidencias {{PeriodoListado}}</h6>
                            <hr>
                        </div>
                    </div>
                    <div class="row" v-else-if="AreaUsuario.AreaId!=79 && (Antiguedad.Años!=0 || Antiguedad.Meses!=0 || Antiguedad.Dias!=0)">
                        <div class="form-group col-12" >
                            <h6 class="label-black">Historial de Incidencias {{PeriodoListado}}</h6>
                            <hr>
                        </div>
                    </div>

                    <div class="row" v-if="(AreaUsuario.AreaId==79 || AreaUsuario.AreaId==25)">
                        <div class="form-group col-8" >
                            <h6 class="label-black">Total de Incidencias Registradas : {{DatosPersona.Incidencias.length}}</h6>
                        </div>
                        <div class="form-group col-4" v-if="DatosPersona.Incidencias.length >0">
                            <Incidencia
                             v-on:valorParaElPadre="cambioDeIncidencia" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'catalogoIncidencias'" 
                            :parametros="parametros_Incidencia" 
                            :valorDefinido="parametros_Incidencia.tipoIncidenciaId"
                            ></Incidencia>
                        </div>
                    </div>
                    <div class="row" v-else-if="(AreaUsuario.AreaId!=79 && AreaUsuario.AreaId!=25) && (Antiguedad.Años!=0 || Antiguedad.Meses!=0 || Antiguedad.Dias!=0)">
                        <div class="form-group col-8" >
                            <h6 class="label-black">Total de Incidencias Registradas : {{DatosPersona.Incidencias.length}}</h6>
                        </div>
                        <div class="form-group col-4" v-if="DatosPersona.Incidencias.length >0">
                            <Incidencia
                             v-on:valorParaElPadre="cambioDeIncidencia" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'catalogoIncidencias'" 
                            :parametros="parametros_Incidencia" 
                            :valorDefinido="parametros_Incidencia.tipoIncidenciaId"
                            ></Incidencia>
                        </div>
                    </div>

                    <div class="row text-center" id="RHDetallesIncidencias_div" v-if="(AreaUsuario.AreaId==79 || AreaUsuario.AreaId==25)">
                        <div class="col-12 table-responsive">
                            <table class="table table-striped table-light table-hover table-sm">
                                        <thead class="thead-custom">
                                            <tr>
                                            <th>Folio</th>
                                            <th>Tipo de Incidencia</th>
                                            <th>Categoría</th>
                                            <th>Fecha Registro</th>
                                            <th class="text-center">Estatus</th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            </tr>
                                        </thead>
                                        <tbody class="text-dark">
                                            <tr v-if="IncidenciasFiltradas <= 0">
                                                <td colspan="12" class="text-center">No hay registro de Incidencias</td>
                                            </tr>
                                                <tr v-else v-for="incidencias in IncidenciasFiltradas" :key="incidencias.IncidenciaId">
                                                <td class="text-center" width="60">{{incidencias.IncidenciaId}}</td>
                                                <td width="300">{{incidencias.TipoIncidencia.Nombre}}</td>
                                                <td width="350" v-if="incidencias.TipoSubIncidencia!=null">{{incidencias.TipoSubIncidencia.Nombre}}</td>
                                                <td width="350" v-else></td>
                                                <td width="250" v-html="obtenFechaConFormato(incidencias.FechaDeRegistro)" style="width: 100px;"></td>
                                                <td class="text-center" width="80" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId==1">
                                                    <span class="badge badge-pill badge-warning text-center">{{incidencias.EstatusIncidencia.Nombre}}</span>
                                                </td>
                                                <td class="text-center" width="80" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId==2">
                                                    <span class="badge badge-pill badge-info text-center">{{incidencias.EstatusIncidencia.Nombre}}</span>
                                                </td>
                                                <td class="text-center" width="80" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId==3">
                                                    <span class="badge badge-pill badge-success text-center">{{incidencias.EstatusIncidencia.Nombre}}</span>
                                                </td>
                                                <td class="text-center" width="80" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId==4">
                                                    <span class="badge badge-pill badge-danger text-center">{{incidencias.EstatusIncidencia.Nombre}}</span>
                                                </td>
                                                <td class="text-center" width="30">
                                                    <a v-on:click="VerDetalles(incidencias)" title="Ver mas">
                                                        <i class="far fa-eye"></i>
                                                    </a>
                                                </td>
                                                <td class="text-center" width="30" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId!=4">
                                                    <a v-on:click="CambiarEstatus(incidencias)" title="Cambiar Estatus">
                                                        <i class="fas fa-pen-square"></i>
                                                    </a>
                                                </td>
                                                <td width="30" v-else></td>
                                                <td class="text-center" width="30" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId!=4 && (incidencias.TipoIncidencia.TipoIncidenciaId !=1 && incidencias.TipoIncidencia.TipoIncidenciaId !=8 && incidencias.TipoIncidencia.TipoIncidenciaId !=9) ">
                                                    <a v-on:click="CambiarFechas(incidencias)" title="Editar Fechas">
                                                        <i class="far fa-calendar-alt"></i>
                                                    </a>
                                                </td>
                                                <td class="text-center" width="30" v-else></td>
                                                <td class="text-center" width="30" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId!=4">
                                                    <a v-if ="incidencias.RutaPlatillaGuardada==null" v-on:click="GenerarPlantilla(false, incidencias)" title="Generar Plantilla">
                                                        <i class="far fa-file-word"></i>
                                                    </a>
                                                    <a v-else v-on:click="GenerarPlantilla(true, incidencias)" title="Descargar Plantilla">
                                                        <i class="fas fa-file-download"></i>
                                                    </a>
                                                </td>
                                                <td width="30" v-else></td>
                                                <td class="text-center" width="30" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId!=4 && incidencias.RutaPlatillaGuardada!=null">
                                                    <a v-on:click="SubirDigital(incidencias)" title="Subir Digitalización">
                                                        <i class="fas fa-file-upload"></i>
                                                    </a>
                                                </td>
                                                <td width="30" v-else></td>
                                                <td  class="text-center" width="30" v-if="incidencias.EstatusIncidencia.Nombre !='Cancelado' && incidencias.RutaDigital!=null">
                                                    <a v-on:click="VerDigital(incidencias)" title="Ver Digitalización">
                                                        <i class="far fa-file-pdf"></i>
                                                    </a>
                                                </td>
                                                <td width="30" v-else></td>
                                                
                                            </tr>
                                        </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row" id="UserDetallesIncidencias_div" v-if="(AreaUsuario.AreaId!=79 && AreaUsuario.AreaId!=25) && (Antiguedad.Años!=0 || Antiguedad.Meses!=0 || Antiguedad.Dias!=0)">
                        <div class="col-12 table-responsive">
                            <table class="table table-striped table-light table-hover table-sm">
                                    <thead class="thead-custom">
                                        <tr>
                                        <th>Folio</th>
                                        <th>Tipo de Incidencia</th>
                                        <th>Categoría</th>
                                        <th>Fecha de Registro</th>
                                        <th>Estatus</th>
                                        <th></th>
                                        <th></th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-dark">
                                        <tr v-if="IncidenciasFiltradas <= 0">
                                            <td colspan="12" class="text-center">No hay registro de Incidencias</td>
                                        </tr>
                                            <tr v-else v-for="incidencias in IncidenciasFiltradas" :key="incidencias.IncidenciaId">
                                            <td width="50">{{incidencias.IncidenciaId}}</td>
                                            <td width="400">{{incidencias.TipoIncidencia.Nombre}}</td>
                                            <td width="350" v-if="incidencias.TipoSubIncidencia!=null">{{incidencias.TipoSubIncidencia.Nombre}}</td>
                                            <td width="350" v-else></td>
                                            <td width="150" v-html="obtenFechaConFormato(incidencias.FechaDeRegistro)" style="width: 100px;"></td>
                                            <td class="text-center" width="80" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId==1">
                                                <span class="badge badge-pill badge-warning text-center">{{incidencias.EstatusIncidencia.Nombre}}</span>
                                            </td>
                                            <td class="text-center" width="80" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId==2">
                                                <span class="badge badge-pill badge-info text-center">{{incidencias.EstatusIncidencia.Nombre}}</span>
                                            </td>
                                            <td class="text-center" width="80" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId==3">
                                                <span class="badge badge-pill badge-success text-center">{{incidencias.EstatusIncidencia.Nombre}}</span>
                                            </td>
                                            <td class="text-center" width="80" v-if="incidencias.EstatusIncidencia.TipoEstatusIncidenciaId==4">
                                                <span class="badge badge-pill badge-danger text-center">{{incidencias.EstatusIncidencia.Nombre}}</span>
                                            </td>
                                            <td width="30">
                                                <a v-on:click="VerDetalles(incidencias)" title="Ver mas">
                                                    <i class="far fa-eye"></i>
                                                </a>
                                            </td>
                                            <td width="30" v-if="incidencias.EstatusIncidencia.Nombre !='Cancelado'">
                                                <a v-if ="incidencias.RutaPlatillaGuardada==null" v-on:click="GenerarPlantilla(false, incidencias)" title="Generar Plantilla">
                                                    <i class="far fa-file-word"></i>
                                                </a>
                                                <a v-else v-on:click="GenerarPlantilla(true, incidencias)" title="Descargar Plantilla">
                                                    <i class="fas fa-file-download"></i>
                                                </a>
                                            </td>
                                            <td width="30" v-else></td>
                                        </tr>
                                    </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="AreaUsuario.AreaId==79">
                        <button class="btn btn-custom btn-sm" @click='AgregarIncidencia()'>Agregar Incidencia</button>
                    </div>
                    <div v-else-if="AreaUsuario.AreaId!=79 && (Antiguedad.Años!=0 || Antiguedad.Meses!=0 || Antiguedad.Dias!=0)">
                        <button class="btn btn-custom btn-sm" @click='AgregarIncidencia()'>Agregar Incidencia</button>
                    </div>
                </div>
            </div>

        </div>
        <div v-if="verModalLista==true">
            <Seleccion :ListaDePersonal = this.ListaPersonas @Resultado='ModalEnvio($event)'></Seleccion>
        </div>
        <div v-if="verModalDetalles==true">
            <Detalles 
            :detalles = this.DetallesDeLaIncidencia 
            :ListadoInhabiles= this.DiasInhabiles 
            :Editar= this.EditarFechas 
            :diasModal= this.diasModalVacaciones 
            :listadoIncidencias= this.incidenciasModal 
            :Nomina= this.DatosPersona.NumeroNomina  
            @Estatus='ModalIncidenteDetalles($event)'></Detalles>
        </div>
        <div v-if="verModalNueva==true">
            <NuevaIncidencia :PersonaModal = this.DatosPersona :ListadoInhabiles= this.DiasInhabiles :Estatus= this.EstatusParaIncidencia :areaGenera = this.AreaUsuario @dialogo='ModalIncidenciaNuevo($event)'></NuevaIncidencia>
        </div>
        <div v-if="verModalEstatus==true">
            <EstatusIncidencia :incidencia = this.IncidenciaAEstatus :nomina= this.DatosPersona.NumeroNomina @dialogo='ModalIncidenciaEstatus($event)'></EstatusIncidencia>
        </div>
        

    </div>
</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import modalLista from '@/components/SIAP/Incidencias/ModalLista.vue'
import modalDetalles from '@/components/SIAP/Incidencias/ModalDetalles.vue'
import modalNueva from '@/components/SIAP/Incidencias/NuevaIncidencia.vue'
import modalEstatus from '@/components/SIAP/Incidencias/ModalEstatus'

export default {
    props:{
        NominaProps: {
            type: Number,
            default: 0
        },
        Actualizar: false
    },
    components :{
        Seleccion : modalLista,
        Detalles : modalDetalles,
        NuevaIncidencia: modalNueva,
        Incidencia: catalogos.SIAP.C033TipoIncidencias,
        EstatusIncidencia: modalEstatus,
    },
    data(){
        return{
            enumeraciones,
            parametros_Incidencia :{
                tipoIncidenciaId: -1
            },
            busqueda: {
                Nombre: "",
                Nomina: null
            },
            DatosPersona:{},
            DetallesDeLaIncidencia: {},
            ListaPersonas: [], 
            verModalLista: false,
            verModalDetalles: false,
            verModalEstatus: false,
            verModalNueva: false,
            verModalSubidor: false,
            DiasInhabiles: [],
            IncidenciasFiltradas:[],
            IncidenciaAEstatus:{},
            EditarFechas: false,
            diasModalVacaciones: 0,
            incidenciasModal: [],
            AreaUsuario:{},
            Titular: false,
            Usuario : {},
            PeriodoListado : null,
            Antiguedad: {
                Años: 0,
                Meses: 0,
                Dias: 0,
                Etiqueta: "",
                ParaApi: ""
            },
            EstatusParaIncidencia: {
                Vacaciones: false,
                DiaEconomico: false,
                Base: false
            }
        }
    },
    methods :{
        CambiaNombre(){
            if(this.busqueda.Nombre!="")
            {
                this.busqueda.Nomina = null;
            }
        },
        CambiaNomina(){
            if(this.busqueda.Nomina!=null)
            {
                this.busqueda.Nombre = "";
            }
        },
        cambioDeIncidencia(datos){
            this.parametros_Incidencia.tipoIncidenciaId = parseInt(datos.target.value);
            this.filtrarIncidencias(this.parametros_Incidencia.tipoIncidenciaId);
        },
        obtenFechaConFormato: function(fechaRegistro) {
            return moment(fechaRegistro).format("DD-MM-YYYY");
        },
        BuscarServidor(nomina){
            var area= this.AreaUsuario.AreaId;
            this.DatosPersona = {};
            this.Antiguedad = {};
            this.IncidenciasFiltradas= [];
            if(nomina!=undefined)
            {
               this.busqueda.Nomina =  nomina; 
            };
           
           if(this.ValidarParametros()) 
           {             
                var peticion = {
                    "Nombre": this.busqueda.Nombre,
                    "Nomina": parseInt(this.busqueda.Nomina, 10),
                        };
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.SIAP.funcion.ListadoIncidenciasPersonal, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
            if (respuesta.data.SiHayError == false) {
                    var ObtenerPersona = respuesta.data.ListadoPersonal;
                    this.DiasInhabiles = respuesta.data.DiasInhabiles;
                
                    switch (ObtenerPersona.length)
                    {
                        case 0 :
                            {
                                comun.mensajeDeAlerta("No se encontraron registros", null, null);
                                this.verModalLista= false;
                                break;
                            }
                        case 1 :
                            {
                                
                                if(this.Titular==true)
                                {
                                    if(ObtenerPersona[0].EstructuraOrganica.TipoDepartamentoArea.Area.AreaId==area)
                                    {
                                        this.DatosPersona = ObtenerPersona[0];
                                        this.ListaPersonas = [];
                                        this.verModalLista= false;
                                        this.IncidenciasFiltradas = this.DatosPersona.Incidencias;
                                        var baseaEnviar = this.DatosPersona.EstructuraOrganica.TipoPlaza.TipoPlazaId==2 ? true : false;
                                        this.EstatusParaIncidencia = {
                                            Vacaciones: false,
                                            DiaEconomico : false,
                                            Base : baseaEnviar}
                                        // this.EstatusParaIncidencia.DiaEconomico = false;
                                        // this.EstatusParaIncidencia.Base = this.DatosPersona.EstructuraOrganica.TipoPlaza.TipoPlazaId==2? true : false;
                                        this.CalculoAntiguedad(ObtenerPersona[0]);
                                        
                                    }
                                    else
                                    {
                                        comun.mensajeDeAlerta("La Consulta no corresponde al Personal del Área", null, null);
                                    }
                                }
                                else
                                {
                                    this.DatosPersona = ObtenerPersona[0];
                                    this.ListaPersonas = [];
                                    this.verModalLista= false;
                                    var baseaEnviar = this.DatosPersona.EstructuraOrganica.TipoPlaza.TipoPlazaId==2 ? true : false;
                                    this.EstatusParaIncidencia = {
                                            Vacaciones: false,
                                            DiaEconomico : false,
                                            Base : baseaEnviar}
                                    // this.EstatusParaIncidencia.Vacaciones= false;
                                    // this.EstatusParaIncidencia.DiaEconomico = false;
                                    // this.EstatusParaIncidencia.Base = this.DatosPersona.EstructuraOrganica.TipoPlaza.TipoPlazaId==2? true : false;
                                    
                                    this.CalculoAntiguedad(ObtenerPersona[0]);
                                    
                                    this.IncidenciasFiltradas = this.DatosPersona.Incidencias;
                                    
                                }
                                break;
                            }
                        default:
                            {
                                this.DatosPersona = {};
                                if(this.Titular==true)
                                {
                                    var filtrado = ObtenerPersona.filter(condicion=>condicion.EstructuraOrganica!=null && condicion.EstructuraOrganica.TipoDepartamentoArea.Area.AreaId == area);
                                    if(filtrado.length>0)
                                    {
                                        this.ListaPersonas = filtrado;
                                        this.verModalLista= true;
                                    }
                                    else
                                    {
                                        this.verModalLista= false;
                                        comun.mensajeDeAlerta("Sin coincidencias en Personal del Área", null, null);
                                    }
                                }
                                else
                                {
                                    this.ListaPersonas = ObtenerPersona;
                                    this.verModalLista= true;
                                }
                                
                                //this.DiasInhabiles
                            }
                    };
                
                
                this.busqueda.Nomina = null;
                this.busqueda.Nombre = "";
                
            } else {
                
                console.error(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }
            comun.SeEstaCargandoInformacion(false);
            })
            .catch(e => {
                comun.SeEstaCargandoInformacion(false);
                console.error("encontre un error " + e);
                comun.mensajeDeAlerta( comun.mensajeDeError(enumeraciones.error.E500), null, null );
            });
            }
        },
        ValidarParametros(){
            if(this.busqueda.Nombre == "" && this.busqueda.Nomina == null )
            {
                comun.mensajeDeAlerta("Los Parametros en la busqueda debe contener Nombre del servidor o Numero de Nómina", null, null);
                this.busqueda.Nomina = null;
                this.busqueda.Nombre = null;
                return false;
            };
            if(this.busqueda.Nombre != "" && this.busqueda.Nomina != null )
            {
                comun.mensajeDeAlerta("Determine solo un parametro, Nombre del servidor o Numero de Nómina para realizar la busqueda", null, null);
                this.busqueda.Nomina = null;
                this.busqueda.Nombre = null;
                return false;
            };
            if(this.busqueda.Nomina != null && parseInt(this.busqueda.Nomina) <=0)
            {
                comun.mensajeDeAlerta("El Numero de Nómina debe ser mayor de Cero", null, null);
                this.busqueda.Nomina = null;
                this.busqueda.Nombre = null;
                return false;
            };
            return true;
        },
        ModalEnvio(datos){
            if(datos.Persona.PersonaId>0)
            {
                this.DatosPersona = datos.Persona;
                this.CalculoAntiguedad(datos.Persona);
                this.IncidenciasFiltradas = this.DatosPersona.Incidencias;
            }
            else
            {
                comun.mensajeDeAlerta( "No se seleccionó ningun Servidor Público", null, null );
            }
            
            this.verModalLista = datos.Estatus;
        },
        ModalIncidenteDetalles(datos){
            this.verModalDetalles = datos.Cerrar;
            var numNomina = datos.Nomina;
            this.DetallesDeLaIncidencia = {};
            this.EditarFechas = false;
            if(datos.Actualizar == true)
            {
                this.BuscarServidor(numNomina);
            }
        },
        ModalIncidenciaNuevo(datos) {
            this.verModalNueva = datos.Cerrar;
            var numNomina = datos.Nomina;
            if(datos.Actualizar == true)
            {
                this.BuscarServidor(numNomina);
            }
        },
        ModalIncidenciaEstatus(datos){
            this.verModalEstatus = datos.Cerrar;
            var numNomina = datos.Nomina;
            if(datos.Actualizar == true)
            {
                this.BuscarServidor(numNomina);
            }
        },
        VerDetalles(datos){
            this.DetallesDeLaIncidencia = datos;
            this.verModalDetalles = true;
        },
        CambiarEstatus(datos){
            this.IncidenciaAEstatus = datos;
            this.verModalEstatus = true;
        },
        AgregarIncidencia(){
            this.busqueda.Nombre="";
            this.busqueda.Nomina = null;
            this.verModalNueva = true;
        },
        filtrarIncidencias(incidencia){
            if(incidencia!=-1)
            {
                this.IncidenciasFiltradas= this.DatosPersona.Incidencias.filter(e=>e.TipoIncidencia.TipoIncidenciaId==incidencia);
                // if(this.IncidenciasFiltradas.length >5)
                // {
                //     this.$nextTick(() => {PaginarTabla("Incidencias_table", 5);});
                // }
            }
            else
            {
                this.IncidenciasFiltradas= this.DatosPersona.Incidencias;
                // if(this.IncidenciasFiltradas.length >5)
                // {
                //     this.$nextTick(() => {PaginarTabla("Incidencias_table", 5);});
                // }
            }
        },
        GenerarPlantilla: function(bool, incidencia){

            if(bool==false)
            {
                var Antiguedad = (this.Antiguedad.Años<1? "": this.Antiguedad.Años + " Años, ") + (this.Antiguedad.Meses<1? "": this.Antiguedad.Meses + " Meses, ") + (this.Antiguedad.Dias<1? "": this.Antiguedad.Dias + " Días");
                var peticion = {"Incidencia": incidencia, "Antiguedad": Antiguedad };
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.SIAP.funcion.GenerarPlantilla, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then(respuesta => {
                if (respuesta.data.SiHayError == false) {
                    var ruta =respuesta.data.rutaArchivo;
                    bootbox.confirm({
                                        title: "Mensaje del sistema",
                                        message: "Se ha Generado la Plantilla con datos, Desea descargar plantilla?",
                                        buttons: {
                                            cancel: {
                                            label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                                        },
                                        confirm: {
                                            label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                                        }
                                    },
                                    callback: (respuesta)=> {
                                        if (respuesta) {
                                            if(ruta != undefined){
                                                var a = document.createElement("a");
                                                document.body.appendChild(a);
                                                a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${ruta}`
                                                a.click();
                                            }
                                        }
                                    }
                                    });

                    this.BuscarServidor(incidencia.PersonaIncidencia.NumeroNomina)
                    
                } else {
                    console.error(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                comun.SeEstaCargandoInformacion(false);
                })
                .catch(e => {
                    console.error("encontre un error " + e);
                    comun.mensajeDeAlerta( comun.mensajeDeError(enumeraciones.error.E500), null, null );
                    });
            }
            else
            {
                //debugger
                var urlDocumento = incidencia.RutaPlatillaGuardada;
                if(urlDocumento != undefined){
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${urlDocumento}`
                    a.click();
                }
            }
        }, 
        SubirDigital(datos){
            if(datos.Digitalizado==false || datos.Digitalizado==null)
            {
                router.push({name: "SubirDigitalIncidencia", params: {incidencia: datos, subir: true}});
            }
            else{
                bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Esta Incidencia ya tiene una Digitalización Almacenada, Desea registrar otra?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: function (respuesta) {
                    if (respuesta) {
                        router.push({name: "SubirDigitalIncidencia", params: {incidencia: datos, subir: true}});
                        }
                    }
                });
            }
            
        },
        CambiarFechas(datos){
            var anio = datos.Detalles[0].Anio !=null ? datos.Detalles[0].Anio : 0;
            var periodo = datos.Detalles[0].Periodo!=null ? datos.Detalles[0].Periodo : 0;
            var Solicitados = [];
            var TotalSolicitados = 0;
            Solicitados = this.DatosPersona.Incidencias.filter(e=>e.TipoIncidencia.TipoIncidenciaId==2 && e.TipoSubIncidencia.TipoSubIncidenciaId==2 && e.EstatusIncidencia.TipoEstatusIncidenciaId !=4 && e.IncidenciaId!=datos.IncidenciaId);
        
            $.each(Solicitados, function(index, lista)
            {
                $.each(lista.Detalles, function(index, detalles)
                {
                    if(detalles.Anio == anio && detalles.Periodo== periodo)
                    {
                        TotalSolicitados = TotalSolicitados + detalles.DiasVacaciones;
                        
                    }
                })
            });
            this.incidenciasModal = this.DatosPersona.Incidencias;
            this.diasModalVacaciones = TotalSolicitados;
            this.EditarFechas = true;
            this.DetallesDeLaIncidencia = datos;
            this.verModalDetalles = true;
        },
        VerDigital: function (datos){
            if(datos.RutaDigital!=null)
            {
                const ObtenerStream = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${datos.RutaDigital}`;
                try {
                    axios.get(ObtenerStream, { responseType: 'blob' })
                    .then(respuesta => {   
                    const pdfWindow = window.open(URL.createObjectURL(new Blob([respuesta.data], {type: 'application/pdf'})), '_blank');
                            })
                    .catch(excepcion => {
                                console.log(excepcion);
                                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                        })
                    }
                    catch(exeption) {
                    console.log(exeption);
                }
            }
        },
        VerificarTitular: function(){
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.SIAP.funcion.VerificarUsuario, null, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
            if (respuesta.data.SiHayError == false) {
                this.Titular = respuesta.data.Titular;
                this.Usuario = respuesta.data.InfoUsuario;
                if(this.Titular==false)
                {
                    this.DatosPersona = respuesta.data.Persona;
                    this.IncidenciasFiltradas = this.DatosPersona.Incidencias;
                    this.EstatusParaIncidencia.Vacaciones= false;
                    this.EstatusParaIncidencia.DiaEconomico = false;
                    this.EstatusParaIncidencia.Base = this.DatosPersona.EstructuraOrganica.TipoPlaza.TipoPlazaId==2 ? true : false;
                    this.CalculoAntiguedad(this.DatosPersona);
                    
                }
                else
                {
                    this.DatosPersona={};
                    
                }
                
            } else {
                console.error(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }
            comun.SeEstaCargandoInformacion(false);
            })
            .catch(e => {
            console.error("encontre un error " + e);
            comun.mensajeDeAlerta( comun.mensajeDeError(enumeraciones.error.E500), null, null );
            });
        },
        CalculoAntiguedad(persona){
            this.EstatusParaIncidencia.Vacaciones = false;
            this.EstatusParaIncidencia.DiaEconomico = false;
            //this.EstatusParaIncidencia.Base = false;

            var diasTotales = 0;
            var periodoContinuo = false;
            if(persona.HistorialLaboral!=null && persona.HistorialLaboral.length>0)
            {
                $.each(persona.HistorialLaboral, function(index, Historia)
                {
                    if(Historia.TipoMovimiento.TipoMovimientoId!=12)
                    { 
                        var FechaInicial = moment(Historia.FechaInicial);
                        var FechaFinal= Historia.FechaFinal!=null ? moment(Historia.FechaFinal) : moment();
                        diasTotales += FechaFinal.diff(FechaInicial, 'days');
                        if(Historia.TipoMovimiento.TipoMovimientoId==25 && (FechaFinal.diff(FechaInicial, 'days') + 1)>15)
                        {
                            diasTotales = diasTotales - FechaFinal.diff(FechaInicial, 'days') 
                        }
                    }
                });
                
                var ultimoPeriodoInicio = moment(persona.HistorialLaboral[0].FechaInicial);
                var ultimoPeriodoFinal = persona.HistorialLaboral[0].FechaFinal!=null ? moment(persona.HistorialLaboral[0].FechaFinal) : moment();
                var diasUltimoPeriodo = ultimoPeriodoFinal.diff(ultimoPeriodoInicio, 'days');
                var estatus = this.ObtenerAntiguedadPorDias(diasUltimoPeriodo);

                if(estatus.Años<2)
                {
                    if(persona.HistorialLaboral.length>1)
                    {
                        var penultimoPeriodoInicio = moment(persona.HistorialLaboral[1].FechaInicial);
                        var penultimoPeriodoFinal = persona.HistorialLaboral[1].FechaFinal!=null ? moment(persona.HistorialLaboral[1].FechaFinal) : moment();

                        var diasPenultimoPeriodo = penultimoPeriodoFinal.diff(penultimoPeriodoInicio, 'days');
                        if(persona.HistorialLaboral[1].TipoMovimiento.TipoMovimientoId==23 || persona.HistorialLaboral[1].TipoMovimiento.TipoMovimientoId!=12)
                        {
                            periodoContinuo =  ultimoPeriodoInicio.diff(penultimoPeriodoFinal, 'days')>15 ? false: true;
                        }
                        if(periodoContinuo == true)
                        {
                            estatus = this.ObtenerAntiguedadPorDias(diasUltimoPeriodo + diasPenultimoPeriodo);
                        };
                        
                    }
                }
                switch(estatus.Años)
                {
                case 0:
                    if(estatus.Meses>=6)
                        {
                            this.EstatusParaIncidencia.Vacaciones = true;
                            this.EstatusParaIncidencia.DiaEconomico= false;
                        }
                    else
                        {
                            this.EstatusParaIncidencia.Vacaciones = false;
                            this.EstatusParaIncidencia.DiaEconomico= false;
                        }
                            
                    break;
                case 1:
                    this.EstatusParaIncidencia.Vacaciones = true;
                    this.EstatusParaIncidencia.DiaEconomico= false;
                    break;
                default:
                    this.EstatusParaIncidencia.Vacaciones = true;
                    this.EstatusParaIncidencia.DiaEconomico= true;
                    break;
                }
                this.Antiguedad = this.ObtenerAntiguedadPorDias(diasTotales);
                this.Antiguedad.Etiqueta =  this.CampoAntiguedad();
            }
            else 
            {
                this.Antiguedad.Años = 0;
                this.Antiguedad.Meses = 0;
                this.Antiguedad.Dias = 0;
            }
        },
        ObtenerAntiguedadPorDias: function (dias)
        {
            var Calculo =  {
                Años: 0,
                Meses: 0,
                Dias: 0
            };
            var AnioFraccion = dias / 365.25;
            var Anio = Math.trunc(AnioFraccion);
            var mesesFraccion = (AnioFraccion - Anio) * 12
            var meses = Math.trunc(mesesFraccion);
            var dias = Math.trunc((mesesFraccion - meses)* 31);
            
            Calculo.Años = Anio;
            Calculo.Meses = meses;
            Calculo.Dias = dias;

            return Calculo;
        },
        CampoAntiguedad(){
            var dato = "Antigüedad Total : " + this.Antiguedad.Años + " Años, " + this.Antiguedad.Meses + " Meses, " + this.Antiguedad.Dias + " Días"
            return dato;
        },
        async verificarAreaTitularidad()
        {
            this.AreaUsuario = this.$store.state.Login_Usuario.Area;
            if(this.NominaProps>0)
            {
                this.BuscarServidor(this.NominaProps);
            };
            if(this.AreaUsuario.AreaId!=79)
            {
                this.VerificarTitular();
            };
            this.PeriodoListado = moment().format('YYYY');
        }

    },
    mounted(){
        this.verificarAreaTitularidad();
    }
}

</script>
<style scoped>
input[type="text"]:read-only {
    background: #f3f3f3;
}
input[type="text"]:read-only:focus {
    color: #fff;
}
.fuente:hover {
  color: #252421;
}
.parpadea {
  animation-name: parpadeo;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  -webkit-animation-name:parpadeo;
  -webkit-animation-duration: 2s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}
.thead-custom {
  background-color: #004746;
  color: white;
}
.custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/SIAP/Incidencias/GestionIncidencias.vue